import { ref } from 'vue';

export function useCmgApi() {
  const settings = ref(null);
  const pageConfig = ref(null);
  const loading = ref(false);
  const error = ref(null);

  async function fetchSettings(careType = 'assmat') {
    loading.value = true;
    error.value = null;

    try {
      const response = await fetch(`/api/calculators/cmg/settings?care_type=${careType}`);
      if (!response.ok) {
        error.value = `Failed to load settings: ${response.status}`;
        return;
      }
      settings.value = await response.json();
    } catch (e) {
      error.value = e.message;
    } finally {
      loading.value = false;
    }
  }

  async function fetchPageConfig(origin, contractId = null, careType = 'assmat') {
    try {
      const params = new URLSearchParams();
      if (origin) params.set('origin', origin);
      if (contractId) params.set('contract_id', contractId);
      params.set('care_type', careType);
      const query = params.toString();
      const url = `/api/calculators/cmg/page_config?${query}`;
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return null;
      pageConfig.value = await response.json();
      return pageConfig.value;
    } catch (_e) {
      return null;
    }
  }

  async function fetchContractData(contractId) {
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      const response = await fetch(`/api/calculators/cmg/contracts/${contractId}`, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
        },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (_e) {
      return null;
    }
  }

  return { settings, pageConfig, loading, error, fetchSettings, fetchPageConfig, fetchContractData };
}
